import type { UIStrings } from "@offsilo/ui/strings";
import { m } from "@/paraglide/messages.js";

/** The component library's own words, translated through Paraglide. */
export function uiStrings(): UIStrings {
  return {
    clear: m.ui_clear(),
    close: m.ui_close(),
    more: m.ui_more(),
    loading: m.ui_loading(),
    dismiss: m.ui_dismiss(),
    undo: m.action_undo(),
    retry: m.action_retry(),
    expand: m.ui_expand(),
    collapse: m.ui_collapse(),
    selectAll: m.ui_select_all(),
    clearSelection: m.ui_clear_selection(),
    selected: (count) => m.ui_selected({ count: String(count) }),
    addTo: (name) => m.ui_add_to({ name: name.toLocaleLowerCase() }),
    logged: m.ui_logged(),
    overdue: m.ui_overdue(),
    scrollLeft: m.ui_scroll_left(),
    scrollRight: m.ui_scroll_right(),
    openPanel: m.ui_open(),
    previewing: (who) => m.ui_previewing({ who }),
    exitPreview: m.ui_exit_preview(),
    noResults: m.ui_no_results(),
  };
}
